import React from "react";
import styled from "styled-components";
import { string } from "prop-types";

import DartyLogo from "@components/shared/Icons/Darty";
import FNACLogo from "@components/shared/Icons/FNAC";
import HomeTDLogo from "@components/shared/Icons/HomeTDLogo";
import CitroenLogo from "@components/shared/Icons/Citroen";
import MediaMarktLogo from "@components/shared/Icons/MediaMarktLogo";
import FnacDartyIconContainer from "@components/shared/FnacDartyIconContainer";

import { getStaticAssetURL } from "@lib/getStaticAssetURL";
import { testDriveLocationType } from "@types";

import {
  TEST_DRIVE_TYPE_ID,
  TEST_DRIVE_POINT_STORE_TYPE,
} from "@shared/constants";

const StyledLogo = styled(CitroenLogo)`
  color: ${({ theme, color }) => color ?? theme.colors.citroenBlue};
  height: 2.5rem;
  width: 2.5rem;
`;

const ResultItemLogo = ({ testDrivePoint, color }) => {
  const baseProps = {
    width: "40px",
    height: "40px",
    dataId: `point-logo-${testDrivePoint.storeType}`,
  };

  switch (testDrivePoint.storeType) {
    case TEST_DRIVE_POINT_STORE_TYPE.DARTY:
      return <DartyLogo {...baseProps} />;

    case TEST_DRIVE_POINT_STORE_TYPE.FNAC:
      return <FNACLogo {...baseProps} />;

    case TEST_DRIVE_POINT_STORE_TYPE.HOME:
      return <HomeTDLogo {...baseProps} />;

    case TEST_DRIVE_POINT_STORE_TYPE.MEDIAMARKT:
      return (
        <MediaMarktLogo data-id={`point-logo-${testDrivePoint.storeType}`} />
      );
  }

  if (testDrivePoint.id === TEST_DRIVE_TYPE_ID.FNAC_DARTY) {
    return (
      <FnacDartyIconContainer dataId={`point-logo-${testDrivePoint.id}`} />
    );
  }
  if (testDrivePoint.type === TEST_DRIVE_TYPE_ID.SUPER) {
    return (
      <img
        width={40}
        height={40}
        data-id={`point-logo-${testDrivePoint.id}`}
        src={getStaticAssetURL(`/images/testDrive/ami_super_fan_logo.png`)}
      />
    );
  }

  return (
    <StyledLogo
      color={color}
      data-id={`point-logo-${testDrivePoint.storeType}`}
    />
  );
};

ResultItemLogo.propTypes = {
  storeType: string,
  color: string,
  testDrivePoint: testDriveLocationType,
};

export default ResultItemLogo;
